document.addEventListener('DOMContentLoaded', function () {
  var filtersToggle = document.querySelector('[data-filters-toggle]');
if (filtersToggle) {
  filtersToggle.addEventListener('click', function () {
    filtersWrap.classList.toggle('is-open');
  });
}
  var page = document.querySelector('.collection-page');
  if (!page) return;

  var grid = document.getElementById('CollectionProductGrid');
  var filtersWrap = document.getElementById('CollectionFilters');
  var pagination = document.getElementById('CollectionPagination');

  function buildUrlFromCheckboxes() {
    var checkboxes = filtersWrap.querySelectorAll('.js-filter-checkbox:checked');
    var params = new URLSearchParams();

    checkboxes.forEach(function (checkbox) {
      params.append(checkbox.name, checkbox.value);
    });

    return page.dataset.collectionUrl + '?' + params.toString();
  }

  function fetchAndUpdate(url, pushState) {
    grid.classList.add('is-loading');

    fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + getSectionId())
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newGrid = doc.getElementById('CollectionProductGrid');
        var newFilters = doc.getElementById('CollectionFilters');
        var newPagination = doc.getElementById('CollectionPagination');

        if (newGrid) grid.innerHTML = newGrid.innerHTML;
        if (newFilters) filtersWrap.innerHTML = newFilters.innerHTML;
        if (newPagination) pagination.innerHTML = newPagination.innerHTML;

        grid.classList.remove('is-loading');
        bindFilterEvents();
        bindShowMoreEvent();

        if (pushState) {
          window.history.pushState({}, '', url);
        }
      })
      .catch(function () {
        grid.classList.remove('is-loading');
      });
  }

  function getSectionId() {
    var meta = document.querySelector('[data-section-id]');
    return meta ? meta.dataset.sectionId : '';
  }

  function bindFilterEvents() {
    var checkboxes = filtersWrap.querySelectorAll('.js-filter-checkbox');
    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        var url = buildUrlFromCheckboxes();
        fetchAndUpdate(url, true);
      });
    });

    var toggles = filtersWrap.querySelectorAll('.collection-filter__toggle');
    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var optionsList = toggle.nextElementSibling;
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        optionsList.classList.toggle('is-collapsed', isOpen);
      });
    });
  }

  function bindShowMoreEvent() {
    var showMoreBtn = pagination.querySelector('[data-show-more]');
    if (!showMoreBtn) return;

    showMoreBtn.addEventListener('click', function (event) {
      event.preventDefault();
      var url = showMoreBtn.getAttribute('href');

      fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=' + getSectionId())
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newGrid = doc.getElementById('CollectionProductGrid');
          var newPagination = doc.getElementById('CollectionPagination');

          if (newGrid) grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
          if (newPagination) pagination.innerHTML = newPagination.innerHTML;

          bindShowMoreEvent();
        });
    });
  }

  bindFilterEvents();
  bindShowMoreEvent();
});

